import { createStore } from 'vuex'

import scripts from './scripts';

export default createStore({
  modules: {
    scripts
  }
})
